<template>
  <V2AtomsBaseCard
    size="small"
    class="flex flex-row gap-2 md:gap-4 !max-w-full"
    :class="[wrapperClass, {'hover:border-2 hover:border-semantic-primary-default': ctaBtnLabel, 'h-full': fillHeight, 'shadow-combined-elevation-1': !hideShadow}]"
  >
    <!-- Text Section -->
    <div
      class="flex flex-col md:gap-4 align-middle gap-2 flex-1"
      :class="fillHeight && !ctaBtnLabel ? 'justify-center' : 'justify-between'"
    >
      <div v-if="title || description" class="flex flex-col gap-1 md:gap-2">
        <div
          v-if="title"
          class="font-semibold text-lg/[120%] md:text-2xl/[120%] text-semantic-surface-on-surface"
          v-html="title"
        />
        <div
          v-if="description"
          class="md:text-lg/[150%] text-base/[150%] text-semantic-surface-on-surface"
          v-html="description"
        />
      </div>

      <div v-if="ctaBtnLabel" class="mt-auto">
        <V2AtomsButton
          has-icon-right
          theme="tertiary"
          :to="ctaBtnTo"
          size="small"
          :target="ctaBtnTarget"
        >
          {{ ctaBtnLabel }}
        </V2AtomsButton>
      </div>
    </div>

    <!-- Badge & Image Section -->
    <div
      v-if="badgeTitle || imagePath"
      class="flex flex-col md:gap-4 gap-2 w-[6rem] lg:!w-[9.375rem] h-full"
    >
      <V2AtomsLabel v-if="badgeTitle">
        {{ badgeTitle }}
      </V2AtomsLabel>

      <img
        v-if="imagePath"
        :src="imagePath"
        :class="imageClass"
        class="w-full object-cover flex-grow rounded-2xl"
        alt="image"
      />
    </div>
  </V2AtomsBaseCard>
</template>

<script setup>
defineOptions({
  name: 'V2MoleculesCardHorizontalCard'
})

defineProps({
  title: {
    type: String,
    default: ''
  },

  description: {
    type: String,
    default: ''
  },

  wrapperClass: {
    type: String,
    default: ''
  },

  hideShadow: {
    type: Boolean,
    default: false
  },

  imageClass: {
    type: String,
    default: ''
  },

  ctaBtnLabel: {
    type: String,
    default: ''
  },

  ctaBtnTo: {
    type: String,
    default: ''
  },

  ctaBtnTarget: {
    type: String,
    default: ''
  },

  badgeTitle: {
    type: String,
    default: ''
  },

  imagePath: {
    type: String,
    default: ''
  },

  fillHeight: {
    type: Boolean,
    default: false
  }
})
</script>
